import {
  IContentActions,
  IContentMessages,
} from 'legacy/lut/components/widgets/public/partnerDuplicates/models'
import { Table } from 'legacy/lut/library/list'
import { JSX, useCallback, useMemo, useState } from 'react'

import { IPartner, IPartnerDuplicate, TPartnerDifference } from 'clickNgo/entities/partner/models'
import { Nullable } from 'clickNgo/models/utils'
import { RowState } from 'core-components/library/list/types'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { ApolloMatchRow } from './components/apolloMatchRow/ApolloMatchRow'
import { COLUMNS } from './configs'

interface IApolloMatchesDialogContentProps extends IContentActions, IContentMessages {
  duplicates: IPartnerDuplicate[]
  onSelect?: (item: IPartner) => void
  onPartialReplace?: (field: keyof IPartner, newValue: string, partner: IPartner) => void
  sortDifference?: (a: TPartnerDifference, b: TPartnerDifference) => number
}

export const ApolloMatchesDialogContent = ({
  duplicates,
  onSelect,
  onPartialReplace,
  contentMessages,
  contentActions,
  sortDifference,
}: IApolloMatchesDialogContentProps) => {
  const [openedTab, setOpenedTab] = useState<Nullable<string>>(!onSelect ? 'row-0' : null)

  const changeTabsOpeningState = useCallback((key: string) => {
    setOpenedTab(key)
  }, [])

  const searchResultCrud = useMemo(
    () =>
      new Crud({
        fetcher: new Static(duplicates),
        keyField: 'partnerId',
      }),
    [duplicates]
  )

  const rowTpl = useMemo(
    () =>
      (
        item: IPartnerDuplicate,
        renderChildren: (
          item: IPartnerDuplicate,
          rowState: RowState,
          additional: IObjectAny
        ) => JSX.Element,
        rowState: RowState,
        rowAttrs: IObjectAny,
        additional: IObjectAny
      ) => {
        return (
          <ApolloMatchRow
            key={item.partner.locationId}
            rowAttrs={rowAttrs}
            searchResult={item}
            renderChildren={renderChildren}
            rowState={rowState}
            additional={additional}
            changeTabsOpeningState={changeTabsOpeningState}
            isOpened={rowAttrs.key === openedTab}
            onPartialReplace={onPartialReplace}
            onSelect={onSelect}
            contentMessages={contentMessages}
            contentActions={contentActions}
            sortDifference={sortDifference}
          />
        )
      },
    [
      changeTabsOpeningState,
      openedTab,
      onPartialReplace,
      onSelect,
      contentMessages,
      contentActions,
      sortDifference,
    ]
  )

  return (
    <Table
      source={searchResultCrud}
      columns={COLUMNS}
      header
      pagination
      hasTranslate
      rowTpl={rowTpl}
    />
  )
}
